import React from "react";

import { Truncated } from "~/components/truncated";
import { cx } from "~/tools/class-variance";
import { prop } from "~/tools/prop";

import type { LegendEntry } from "./_legend-entry";
import { LegendEntryLabel } from "./_legend-entry-label";
import type { State } from "./_state";

export interface LegendContentListProps {
	entries: ReadonlyArray<LegendEntry>;
	state: State;
}

export const LegendContentList: React.FC<LegendContentListProps> = ({ entries, state }) => (
	<ul className="m-0 w-full list-none space-y-1 p-0 text-grey-700 text-xs/3.5 transition-colors">
		{entries.map(({ index, label, active, color, componentIdentifier }) => (
			<LegendEntryLabel
				className={cx("flex w-full flex-row flex-nowrap", !active && "text-grey-500")}
				color={color}
				componentIdentifier={componentIdentifier}
				data-testid="time-series-chart-legend-item"
				el="li"
				key={index}
				label={label}
			>
				<Truncated
					className="cursor-pointer text-left transition-colors hover:text-primary-500"
					el="button"
					onClick={({ ctrlKey, shiftKey, metaKey }) => {
						if (ctrlKey || shiftKey || metaKey) {
							state.toggleLabel(label);
						} else {
							state.focusLabel(label, entries.map(prop("label")));
						}
					}}
					type="button"
				>
					{label}
				</Truncated>
			</LegendEntryLabel>
		))}
	</ul>
);
